"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize", "themeColor"];

var HealthSafety = function HealthSafety(props) {
  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M4.16667 9.1667H5.8333V7.50003H7.49997V5.8334H5.8333V4.16673H4.16667V5.8334H2.5V7.50003H4.16667V9.1667ZM4.99998 13.3205C3.55811 12.9274 2.36431 12.0787 1.41858 10.7744C0.472861 9.47012 0 8.01201 0 6.40005V2.56417L4.99998 0.692383L9.99997 2.56417V6.40005C9.99997 8.01201 9.5271 9.47012 8.58138 10.7744C7.63566 12.0787 6.44186 12.9274 4.99998 13.3205ZM4.99998 12.2667C6.15554 11.9001 7.11109 11.1667 7.86665 10.0667C8.62221 8.96672 8.99998 7.74449 8.99998 6.40005V3.25005L4.99998 1.75647L0.999983 3.25005V6.40005C0.999983 7.74449 1.37776 8.96672 2.13332 10.0667C2.88887 11.1667 3.84443 11.9001 4.99998 12.2667Z",
    fill: "#4B4FA6"
  }, colorStyles)));
};

HealthSafety.propTypes = _inline_svg2.default.propTypes;
HealthSafety.defaultProps = _inline_svg2.default.defaultProps;
var _default = HealthSafety;
exports.default = _default;